export default __webpack_public_path__ + "assets/9.89b84c38.png";